import dynamic from "next/dynamic";

export const StatisticsPieChart = dynamic(() => import("./component"));
